
import React from 'react';
import { MessageCircle } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

const FloatingWhatsApp = () => {
  const whatsappLink = "https://wa.me/61469085544";
  
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg hover:bg-[#1da851] transition-colors duration-300"
            aria-label="Chat on WhatsApp"
          >
            <MessageCircle size={28} />
          </a>
        </TooltipTrigger>
        <TooltipContent side="top" className="bg-[#25D366] text-white border-[#25D366]">
          Let's Talk
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default FloatingWhatsApp;
